export default __webpack_public_path__ + "static/media/img-6.22e5e101.jpg";